import React from 'react';

import {Stats} from '@pexip/media-components';

import {useInfinityClient} from '../hooks/useInfinityContext';
import {useSecureCheckCode} from '../hooks/useSecureCheckCode';
import {callSignals} from '../signals/Call.signals';

export const NerdStats: React.FC<{onClose: () => void}> = ({onClose}) => {
    const secureCheckCode = useSecureCheckCode();
    const infinityClient = useInfinityClient();
    return (
        <Stats
            isOpen
            onClose={onClose}
            statsSignal={callSignals.onRtcStats}
            cachedStats={infinityClient.latestStats}
            callQualityStatsSignal={callSignals.onCallQualityStats}
            secureCheckCode={secureCheckCode}
        />
    );
};
